import { useEffect, useState } from 'react';

const useOngoingMonitoring = ({
  batchApplyOngoingWarning,
  batchApplyWarningIsSuccess,
}: {
  batchApplyOngoingWarning: ({
    action,
    comment,
    matchStatus,
  }: {
    action: string;
    comment: string;
    matchStatus?: string | undefined;
  }) => void;
  batchApplyWarningIsSuccess?: boolean;
}) => {
  const [applyAllPopupVisible, setApplyAllPopupVisible] = useState(false);
  const [comment, setComment] = useState('');
  const [action, setAction] = useState('');
  const [matchStatus, setMatchStatus] = useState('');

  const onApplyActions = async () => {
    await batchApplyOngoingWarning({
      action,
      comment,
      matchStatus,
    });
  };

  useEffect(() => {
    if (batchApplyWarningIsSuccess) {
      setApplyAllPopupVisible(false);
      setComment('');
      setAction('');
      setMatchStatus('');
    }
  }, [batchApplyWarningIsSuccess]);

  return {
    setApplyAllPopupVisible,
    setComment,
    setMatchStatus,
    setAction,
    onApplyActions,
    comment,
    action,
    matchStatus,
    applyAllPopupVisible,
  };
};

export default useOngoingMonitoring;
